import React from 'react'
import { useDispatch } from 'react-redux'
import { signOut } from 'actions/auth'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import useIsUserAuthenticated from 'hooks/useIsUserAuthenticated'
import { List, ListItem, ListItemText, makeStyles } from '@material-ui/core'
import { Link as RouterLink } from 'react-router-dom'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  }
}))

export default function NavigationList({ isMobile = false }) {
  const classes = useStyles()
  const isUserSignedIn = useIsUserAuthenticated()
  const hasUserCompletedSupporterOnboarding = useCurrentUserProp('completedSupporterOnboarding')
  const dispatch = useDispatch()
  function handleSignOut() {
    dispatch(signOut())
  }

  const HelpLink = () => (
    <ListItem button component='a' target='_blank' rel='noopener noreferrer' href='https://sixpenceapp.com/features-explained/'>
      <ListItemText primary='Help'/>
    </ListItem>
  )

  return (
    <List component='nav' className={clsx({ [classes.root]: !isMobile })}>
      {isUserSignedIn ? (
        <React.Fragment>
          {hasUserCompletedSupporterOnboarding && (
            <React.Fragment>
              <ListItem button component={RouterLink} to='/home'>
                <ListItemText primary='Home'/>
              </ListItem>
              <ListItem button component={RouterLink} to='/settings'>
                <ListItemText primary='Settings'/>
              </ListItem>
            </React.Fragment>
          )}
          <HelpLink />
          <ListItem button onClick={handleSignOut}>
            <ListItemText primary='Logout'/>
          </ListItem>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <ListItem button component={RouterLink} to='/login'>
            <ListItemText primary='Login'/>
          </ListItem>
          <HelpLink />
        </React.Fragment>
      )}
    </List>
  )
}

NavigationList.propTypes = {
  isMobile: PropTypes.bool
}
